import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class CartRejectedPromotionDto
*  
*/
export class CartRejectedPromotionDto extends ActiveModel {

  /**
  * promotionId
  *   */
  @ActiveField()
  promotionId?: number


/**
  * publicTitle
  * 
  */
  @ActiveField()
  publicTitle?: string


/**
  * terms
  * 
  */
  @ActiveField()
  terms?: null | string
}
